module.exports = __webpack_public_path__ + "da604fa49174f2d153df999414af9ec3.jpg";